import React, { Component } from "react";
import { Button, PageHeader, Modal, FormControl, FormGroup, Row, Col } from "react-bootstrap";
import ReactQuill, { Quill, Mixin, Toolbar } from "react-quill";
import ReactPhoneInput            from "react-phone-input-2";
import ReactPlayer                from 'react-player'
import { FontAwesomeIcon }        from '@fortawesome/react-fontawesome'
import config                     from "../../config";
import KeywordsInput              from "../../components/exercise/KeywordsInput";
import LoaderButton               from "../../components/LoaderButton";
import RenderLander               from "../../components/utils/RenderLander";
import TextAreaMod                from "../../components/TextAreaMod";
import FooterLoadingBar           from "../../components/utils/FooterLoadingBar";
import AutoSuggestClientName      from "../../components/autosuggest/AutoSuggestClientName";
import { handleGoToURL}           from "../../utils/URL";
import { getFiletypeIcon }        from "../../utils/Icons"
import { Colors }                 from "../../utils/Colors";
import { API, Storage }           from "aws-amplify";
import ModalAlert                 from "../../components/modal/ModalAlert";
import { s3Upload, getS3Attachment } from "../../libs/awsLib";

import 'react-quill/dist/quill.snow.css';
import "../../css/document/DocumentNew.css";

import { invokeAddDocument, invokeGetDocumentDetail } from "../../utils/AwsInvoke";

const CHAR_COUNT = 1500;
const NOTES_TEXT = "Private notes about the document";

export default class DocumentNew extends Component {
    constructor(props) {
        super(props);

        this.file = `${this.props.match.params.document_id}`;

        this.state = {
            isLoading: false,
            companyId: "",
            clientName: "",
            clientNameSearch: "",
            clientId: `${this.props.match.params.client_id}`,
            uid: `${this.props.match.params.document_id}`,
            filename: "",
            fileType: "",
            loadingData: "",
            showLoadingBar: "none",
            pageOverlay: "none",
            showConfirmWin: false,
            title: "Add New Document",
            imageURL: "",
            imageSrc: "",
            inputValue: "",

            modalAlertTitleText: "",
            modalAlertBodyText:  "",
            showModalAlert:      false, // true | false
            alertObject:         {},
            alertAction:         "",
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            var client_id = this.state.clientId;
            var uid       = this.state.uid;
            var action    = "";
            //if(client_id === "undefined" && uid === "undefined") {
            if(uid === "undefined")
                action = "new";

            if(uid === "undefined" && client_id === "&") {
                // add other "new" client code
            } else {
                // NEW DOCUMENT With Client ID
                this.getDocumentData(action, client_id, uid);
            }

        } catch (e) {
            alert(e);
        }
    }

    msgDataLoaded = () => {
        this.setState({
            loadingData: ""
        })
    }

    getDocumentData = async (action, client_id, uid) => {
        var title = "Document Profile";
        if(action === "new")
            title = "Add New Document";

            this.setState({
                title: title,
                loadingData: "Loading document data ... "
            })
            const results = await invokeGetDocumentDetail(action, client_id, uid);

            if(results) {
                var data         = results.data.client_data[0];

                var member_name;
                var filename;
                var file_type;
                var document_id;
                var date;
                var aws_identity_id;

                if(data != undefined) {
                    member_name  = data.first_name + " " + data.last_name;
                    filename     = data.file_name;
                    file_type    = data.file_type;
                    document_id  = data.document_id;
                    date         = data.date_created;
                    aws_identity_id         = data.aws_identity_id;
                }
                console.log("data: " + data);
                console.log("filename: " + filename);
                console.log("document_id: " + document_id);
                console.log("aws_identity_id: " + aws_identity_id);

                this.setState({
                    clientName: member_name,
                    filename: filename,
                    fileType: file_type,
                    isLoading: false
                });
                this.msgDataLoaded();
                this.getAttachment(document_id, aws_identity_id);

            } else {
                this.msgDataLoaded();

            }
    }

    async getAttachment (document_id, identityId) {
        var attachmentURL = await getS3Attachment(document_id, identityId);

        console.log("attachmentURL: " + attachmentURL);

        this.setState({
            imageURL: attachmentURL
        })
    }

    cancelDocument = () => {
        this.props.history.goBack();
    }

    handleMemberNameChange  = (client_id, client_name) => {
        this.setState({
            clientNameSearch: client_name,
            clientId: client_id
        });
    }

    handleFilenameChange  = (event) => {
        var text = event.target.value;
        this.setState({
            filename: text
        });
    }

    getImgOrDocTag = (img_src, file_type) => {
        var tag;
        var file_type;

        if(file_type != undefined) {

            file_type = file_type.toLowerCase();
            if(file_type === "png" || file_type === "gif" || file_type === "jpg" || file_type === "jpeg") {

                if(img_src === "") img_src = require('../../images/icons/filetype/file.png');

                tag = <img id="target" src={img_src} style={{maxWidth:"500px", maxHeight:"300px"}}/>
            } else
                tag = <span style={{position:"relative", top:"15px", left:"-7px"}}>
                            { getFiletypeIcon(file_type, 100, 100) /* returns <img src... w={w}, h={h}>*/ }
                      </span>
        } else
            tag = <div style={{color:"red"}}><p/>Sorry, there was an error fetching your file. Please try again.</div>

        return tag;
    }

    handleFileChange = event => {
        if (event.target.files && event.target.files[0]) {
            this.file = event.target.files[0];
            var tmp_file_name = this.file.name; // || .size || ".type"
            var file_type = tmp_file_name.substring(tmp_file_name.lastIndexOf(".")+1);

            this.setState({
                value: event.target.value
            });

            let reader = new FileReader();

            reader.onload = (e) => {
                var img_src_tmp = this.getImgOrDocTag(e.target.result, file_type);

                this.setState({
                    imageSrc: img_src_tmp,
                    fileType: file_type
                });
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    handleSubmit = async event => {
        event.preventDefault();

        var uid         = this.state.uid;
        var client_id   = this.state.clientId;
        var filename    = this.state.filename;
        var company_id = this.props.globalCompanyId;
        var body_text;
        if(client_id === "undefined" || client_id === "&" || client_id === 0) { // client_id: 0 = "No Results"
            body_text  = "A member name is required.";
            this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
            return;
        } else if(filename === "") {
            body_text  = "A filename is required.";
            this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
            return;
        } else if(this.file === "undefined") {
            body_text  = "A document is required.";
            this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
            return;
        }

        if (this.file && this.file.size > config.MAX_ATTACHMENT_SIZE) {
            body_text  = `Please pick a file smaller than ${config.MAX_ATTACHMENT_SIZE/1000000} MB.`;
            this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
            return;
        }

        this.setState({ isLoading: true, showLoadingBar: "inline" });

        try {
            ////  USES THE "BUCKET" FROM CONFIG.JS - BUCKET: "training-slate-admin-prod-documents"   ////
            const document_id = this.file ? await s3Upload(this.file) : null;

            //var attachmentURL = await Storage.vault.get(document_id); //save attach url in db

            var action = "full_save";
            var file_type = this.state.fileType;

            if(this.file != "undefined" && uid != "undefined") action = "title_save";
            if(uid === "undefined") uid = "new";

            const results = await invokeAddDocument(action, client_id, company_id, filename, document_id, uid, file_type);

            if(results.status === true) {
                console.log("+++ the document/file was added +++");
                this.cancelDocument();
            } else {
                body_text  = "Sorry, we had problems adding the document. Please try again";
                this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
                this.resetLoadingBar();
            }
        } catch (e) {
            alert(e);
            this.resetLoadingBar();
        }
    }

    resetLoadingBar = () => {
        this.setState({ isLoading: false, showLoadingBar: "none" });
    }

    handleCloseConfirmWin = (action) => {
        this.file = null;

        this.setState({
            pageOverlay: "none",
            showConfirmWin: false
        });
    }

        handleExerciseChange(id, name, yt_id) {
            this.setState({
                exerc_id: id,
                exerc_name: name,
                youtube_id: yt_id
            });
        }

    renderHome() {

        var input_field;
        var uid         = this.state.uid;
        var client_id   = this.state.clientId;
        var company_id = this.props.globalCompanyId;

        //if(this.state.imageSrc === "" && this.state.file_type === "") {
        if(uid === "undefined") {
            input_field = <FormGroup controlId="file">
                                <Row className="grid">
                                      <Col xs={12} sm={12} md={12}>
                                          <span className="formLabel">
                                              Attach Document
                                          </span>
                                      </Col>
                                </Row>
                                <br/>
                            <label id="documentFile"> Upload a File
                                        <FormControl onChange = {this.handleFileChange}
                                                     style    = {{outline:"none", display: "none", fontSize:"20px", width:"100px" /*width = hide text: 'no file chosen' */}}
                                                     value    = {this.state.inputValue}
                                                     type     = "file" />
                                </label>
                            </FormGroup>
        } else {
            input_field = <span className="pull-left">
                              <a href={this.state.imageURL} className="pull-left" target="_blank">View original file</a>
                              <br/>
                              { this.getImgOrDocTag(this.state.imageURL, this.state.fileType) }
                          </span>
        }

        var textfield;
        var member_name = this.state.clientName;
        if(member_name != "")
            textfield = <span   className="clientListRowMiddleLeft"
                                href= {"/client/detail/"+client_id}
                                style={{cursor:"pointer"}}
                                onClick={(e) => handleGoToURL(e, this, "/client/detail/"+client_id)}>
                            <b className="pull-left">{ member_name }</b>
                        </span>
        else
            textfield = <AutoSuggestClientName
                             handleMemberNameChange={this.handleMemberNameChange.bind(this)}
                             //defaultValue = {""}
                             client_name = {this.state.clientNameSearch}
                             company_id  = {company_id}
                         />


        return (

          <div className="programs">
            <PageHeader>
                    { this.state.title }
                    <span style={{fontSize:"16px", color: "red"}}><br/>{ this.state.loadingData }</span>
            </PageHeader>

            <form onSubmit={this.handleSubmit} className="form">
                <Row className="grid">
                      <Col xs={12} sm={12} md={12}>
                          <span className="formLabel">
                              Member Name
                          </span>
                      </Col>
                </Row>
                <Row className="grid">
                      <Col xs={12} sm={12} md={12}>
                          <span style={{fontSize:"20px", width:"100%"}} className="pull-left">
                              { textfield }
                          </span>
                      </Col>
                </Row>
                <div className="iconAddExercise25pxVertSpacer"></div>

                <Row className="grid">
                      <Col xs={12} sm={12} md={12}>
                          <span className="formLabel">
                              Document Title
                          </span>
                      </Col>
                </Row>
                <Row className="grid">
                      <Col xs={12} sm={12} md={12}>
                          <span>
                                <input type        = "text"
                                       value       = {this.state.filename}
                                       onChange    = {this.handleFilenameChange.bind(this)}
                                       className   = "input-lg tf_addExercise" />
                          </span>
                      </Col>
                </Row>
                <div className="iconAddExercise25pxVertSpacer"></div>
                <div className="iconAddExercise25pxVertSpacer"></div>

                { input_field }

                 <Row className="grid">
                       <Col xs={12} sm={12} md={12}>
                           <span className="formLabel">
                               {this.state.imageSrc}
                           </span>
                           { /*}<ReactPlayer url='https://www.youtube.com/watch?v=ysz5S6PUM-U' />*/ }
                       </Col>
                 </Row>

                <div className="iconAddExerciseVertSpacer"></div>
                <Row className="grid">
                      <Col xs={6} sm={6} md={6}>
                          <span onClick = { () => this.cancelDocument()}>
                              <LoaderButton
                                block
                                type    = "button"
                                text    = "Cancel"
                                style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                              />
                          </span>
                        </Col>
                        <Col xs={6} sm={6} md={6}>
                              <LoaderButton
                                block
                                type    = "submit"
                                text    = "Save"
                                style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                //disabled={!this.validateForm()}
                                isLoading={this.state.isLoading}
                                loadingText="Saving…"
                              />
                        </Col>
                    </Row>
            </form>
            <br/><br/><br/>
          </div>
        );
    }

    render() {
        let closeModalAlert        = () => this.setState({ showModalAlert: false }); //close simple modal window
        return (
              <div className="Home">
                {this.props.isAuthenticated ? this.renderHome() : <RenderLander />}

                    <FooterLoadingBar text={"Saving New Document Data..."}
                                          showLoadingBar={this.state.showLoadingBar}/>

                    {this.state.showModalAlert ?
                        <ModalAlert
                            onHide         = {closeModalAlert}
                            alertFunction  = {this.alertFunction}     // custom function to call within modal
                            alertAction    = {this.state.alertAction} // flag used for above function
                            alertObject    = {this.state.alertObject} // vars used for above function
                            showModalAlert = {this.state.showModalAlert}
                            messageTitle   = {this.state.modalAlertTitleText}
                            messageBody    = {this.state.modalAlertBodyText}
                        />
                    : null}
                    <div>
                        <span className="pageOVerlay" style={{display:this.state.pageOverlay}}></span>
                        <Modal
                               show={this.state.showConfirmWin}
                               onHide={() => this.handleCloseConfirmWin("close")}
                               size            = "lg"
                               centered        = "true"
                               aria-labelledby = "contained-modal-title"
                               className       = "modalBasics"
                             >
                               <Modal.Header closeButton>
                                 <Modal.Title id="contained-modal-title">
                                     <FontAwesomeIcon icon="info-circle" className="modalAlertIcon" />
                                     <span className="modalBasicsTitle">
                                         Document Upload
                                     </span>

                                 </Modal.Title>
                               </Modal.Header>
                               <Modal.Body>
                                   <span className="modalAlertBody">
                                       Congrats, your document was successfully uploaded.
                                   </span>
                               </Modal.Body>
                               <Modal.Footer>
                                   <Button onClick={() => this.handleCloseConfirmWin("close")}>OK</Button>
                               </Modal.Footer>
                         </Modal>
                    </div>
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/document/DocumentNew.js